import { BidsHistoryModal } from 'modules/BuyerActivity/BidsHistoryModal'
import { StyledAuctionText, StyledNumberOfBids } from 'modules/BuyerActivity/VehicleAuction.styled'
import { useContext, useState } from 'react'
import { useDtmAnalytics } from 'hooks/useDtmAnalytics'
import { VehicleContext } from './VehicleContext'

export const VehicleBidHistoryLink = () => {
  const [showBidsHistory, setShowBidsHistory] = useState(false)
  const { userInteraction } = useDtmAnalytics()
  const {
    vehicleData: { vehicle: vehicleInfo, auctionInfo }
  } = useContext(VehicleContext)

  return (
    <>
      {auctionInfo && !auctionInfo.IsDirectSale && (
        <>
          <StyledAuctionText>
            <StyledNumberOfBids
              count={auctionInfo.NumberOfBids}
              onClick={() => {
                userInteraction('bid history')
                setShowBidsHistory(true)
              }}
            >
              {auctionInfo.NumberOfBids}
            </StyledNumberOfBids>
            {' Bids '}
            {vehicleInfo.ReserveMet === 1 && <span className="reserve">(Reserve Met)</span>}
            {vehicleInfo.ReserveMet === 0 && <span className="reserve">(Reserve Not Met)</span>}
          </StyledAuctionText>
          <BidsHistoryModal
            show={showBidsHistory}
            onHide={() => setShowBidsHistory(false)}
            size="lg"
            centered
            auctionInfo={auctionInfo}
            vehicleInfo={vehicleInfo}
            onClose={() => {
              setShowBidsHistory(false)
            }}
          />
        </>
      )}
    </>
  )
}
